package com.loyola.acessoescola.services.adminpanel

import com.loyola.acessoescola.data.Error
import com.loyola.acessoescola.services.quintadb.API_HOST
import com.loyola.acessoescola.services.quintadb.ErrorMessages as QDBErrorMessages
import com.loyola.acessoescola.services.quintadb.ExpiredTokenException
import com.loyola.acessoescola.services.quintadb.UnauthorizedException
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.request.get
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType
import io.ktor.serialization.kotlinx.json.json
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import kotlinx.serialization.json.Json

enum class EndPoints(val endPoint: String) {
    LOGS("$API_HOST/get-logs"),
    SET_AS_UPDATED("$API_HOST/set-as-updated")
}


actual class AdminPanelApi {
    private val httpClient = HttpClient {
        install(ContentNegotiation) {
            json(Json {
                prettyPrint = true
                isLenient = true
                ignoreUnknownKeys = true
            })
        }
    }

    fun getLogs(userIDToken: String): Flow<List<LogEntry>> = flow {
        val response =
            httpClient.get(EndPoints.LOGS.endPoint) {
                headers.append(HttpHeaders.Authorization, "Bearer $userIDToken")
            }

        try {
            val logsResponse: LogsResponse = response.body()
            emit(logsResponse.logs)
        } catch (_: Exception) {
            val error: Error = response.body()

            if (error.errorMessage.contains("expired")) {
                throw ExpiredTokenException(QDBErrorMessages.EXPIRED_TOKEN.message)
            } else {
                throw UnauthorizedException(error.errorMessage)
            }
        }
    }

    fun setAsUpdated(userIDToken: String, logEntry: LogEntry): Flow<Boolean> = flow {
        val response = httpClient.put(EndPoints.SET_AS_UPDATED.endPoint) {
            headers.append(HttpHeaders.Authorization, "Bearer $userIDToken")
            contentType(ContentType.Application.Json)
            setBody(logEntry)
        }

        when (response.status){
            HttpStatusCode.Unauthorized -> {
                val error: Error = response.body()

                if (error.errorMessage.contains("expired")) {
                    throw ExpiredTokenException(QDBErrorMessages.EXPIRED_TOKEN.message)
                } else {
                    throw UnauthorizedException(error.errorMessage)
                }
            }

            HttpStatusCode.OK -> {
                emit(true)
            }

            else -> {
                val error: Error = response.body()
                throw UpdateLogException(error.errorMessage)
            }

        }
    }
}